import { render, staticRenderFns } from "./Upsizhu.vue?vue&type=template&id=4406981a&scoped=true"
import script from "./Upsizhu.vue?vue&type=script&lang=js"
export * from "./Upsizhu.vue?vue&type=script&lang=js"
import style0 from "./Upsizhu.vue?vue&type=style&index=0&id=4406981a&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4406981a",
  null
  
)

export default component.exports